import SocialView from '@/views/social/index';

export default [
  {
    path: '/social',
    name: 'social',
    component: SocialView,
    meta: {
      header: true,
    },
  },
];